<template>
  <div class="container">
    <div id="get-started-card">
      <img
        :src="AbstractLeftImage"
        class="abstract-images"
        alt="abstract-image"
      />
      <div class="title-wrapper">
        <h1 class="section-header">
          Mulailah perjalanan finansial Anda bersama
          <span class="section-header-orange">Efunding!</span>
        </h1>
        <p class="section-description">
          Bergabunglah bersama <strong>Efunding</strong> sekarang juga! kami siap membantu Anda
          mewujudkan tujuan finansial melalui solusi<br /> <strong>keuangan syariah</strong> yang aman,
          transparan, dan penuh keberkahan serta layanan pengguna yang unggul.
        </p>
      </div>
      <button class="button-primary" @click="goToRegistration" style="z-index: 10;">Daftar</button>
    </div>
  </div>
</template>

<script>
// Assets
import AbstractLeftImage from "../../assets/images/landing_page/img-abstract-left.png";

export default {
  name: "CardGetStarted",
  data() {
    return {
      AbstractLeftImage,
    };
  },
  methods: {
    goToRegistration() {
      this.$router.push("/register");
    },
  },
};
</script>

<style scoped>
#get-started-card {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #13346c;
  margin-bottom: 48px;
  padding: 80px;
  border-radius: 20px;
  overflow: hidden;
}
.title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
}
@keyframes float-slow-x {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(8px);
  }
}
.abstract-images {
  position: absolute;
  top: 5px;
  height: 100%;
  left: 5px;
  animation: float-slow-x 6s ease-in-out infinite;
  pointer-events: none;
  opacity: 0.15;
}
.button-primary {
  padding: 15px 25px;
  background-color: #f7bd3a;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.button-primary:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 15px rgba(247, 189, 58, 0.4);
  background-color: #e0a02e;
}
.section-header {
  color: white;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-transform: capitalize;
  line-height: 100%;
  font-size: 35px;
}

.section-header-orange {
  color: #f7bd3a;
  font-weight: 700;
  margin-bottom: 0.5rem;
  
}

.section-description {
  color: #b3b3b3;
  
}

.container {
  max-width: 90%;
}

@media (max-width: 768px) {
  #get-started-card {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #13346c;
    margin-bottom: 48px;
    padding: 80px;
    border-radius: 20px;
    overflow: hidden;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/cardGetStarted.vue